import deleteIcon from "../../assets/images/trash_bin_delete_rgb_red.svg";
import editIcon from "../../assets/images/edit_rgb_dark_green.svg";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../services/httpClient";
import "../../assets/styles/users.scss";

const UsersActionButtons = ({ userId, onEdit, onDelete }) => {
  const navigate = useNavigate();

  const handleEdit = (e) => {
    e.stopPropagation();
    navigate(`/administration/users/edit/${userId}`);
    };

  const handleDelete = async (e) => {
    e.stopPropagation();
    
    const confirmed = window.confirm("Czy na pewno chcesz usunąć tego użytkownika?");
    if (!confirmed) return;

    try {
      await api.delete(`/User/${userId}`);
      window.location.reload();
      if (onDelete) {
        onDelete(userId);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Wystąpił błąd podczas usuwania użytkownika.");
    }
  };

  return (
    <div className="d-flex gap-2 justify-content-center">
      <Button
        variant="link"
        onClick={handleEdit}
        className="p-0"
        title="Edytuj"
      >
        <img src={editIcon} alt="Edit" style={{ width: "28px", height: "28px" }} />
      </Button>
      <Button
        variant="link"
        onClick={handleDelete}
        className="p-0"
        title="Usuń"
      >
        <img src={deleteIcon} alt="Delete" style={{ width: "28px", height: "28px" }} />
      </Button>
    </div>
  );
};

export default UsersActionButtons;